module.exports = __webpack_public_path__ + "close-239719efe269e3e7f1f7.png";